export function loadImage(source: string, factory: () => HTMLImageElement): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = factory();
    const finish = (error?: Error) => {
      clearTimeout(timer); image.onload = null; image.onerror = null;
      if (error) reject(error); else resolve(image);
    };
    const timer = setTimeout(() => finish(new Error('头像读取超时，请重试。')), 15000);
    image.onload = () => finish();
    image.onerror = () => finish(new Error('头像读取失败，请重试。'));
    image.src = source;
  });
}
